export default __webpack_public_path__ + "static/media/GooglePlay.93e8d43d.png";